import { render, staticRenderFns } from "./MapFooterLandowners.vue?vue&type=template&id=58b31ab4&"
import script from "./MapFooterLandowners.vue?vue&type=script&lang=js&"
export * from "./MapFooterLandowners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports